import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CRM_SEARCH_ERROR_HANDLED, CrmSearchErrorNavMarker } from './CrmSearchErrorNavMarker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CrmSearchQueryStringTooLongErrorEmptyState = () => {
  return /*#__PURE__*/_jsxs(ErrorMessage, {
    type: "badRequest",
    children: [/*#__PURE__*/_jsx(CrmSearchErrorNavMarker, {
      name: CRM_SEARCH_ERROR_HANDLED
    }), /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "crmObjectSearchQueryUtilities.errorStates.QueryStringTooLongError.body"
      })
    })]
  });
};